module.exports = __webpack_public_path__ + "static/media/loading.9eeb518b.gif";